const messages = {
  title: "Produktinformationen UND Freigaben",
  description:
    "Willkommen im Broschüren- und Preislistenbereich rund um die Produkte von Bridgestone und Firestone. Hier finden Sie aktuelle Broschüren und Preislisten zu allen Produktbereichen und Pricat Dateien für Ihre Warenwirtschaft.",
};
export default {
  messages,
};
